import { Component } from '@angular/core';

@Component({
  selector: 'bor-faq',
  standalone: false,
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent {}
